import type { DaysByRow } from 'modules/shift_management/hooks/reducers/selection'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'

import { NO_WORK_AREA } from 'modules/shift_management/store/internal/models/Shift'
import { useSelectionState } from './useSelection'

export type ShiftAttributes = {
  location_id: string | null
  work_area_id: string | null
}

export type ShiftInputsAttributes = {
  locationId: string | null
  workAreaId: string | null
}

/**
 * @deprecated Use ShiftInputsAttributesByDate instead, which works using mutations.
 */
export type ShiftsAttributesByDate = Record<string, ShiftAttributes[]>
export type ShiftInputsAttributesByDate = Record<string, ShiftInputsAttributes[]>

// FIXME: This is a temporary solution to handle the different attributes for the shift inputs.
// We should refactor this and use only camelCase once all the mutations are working.
const getDefaultAttributesFromWorkAreas = (
  daysByRow: DaysByRow
): { snakeCase: ShiftsAttributesByDate; camelCase: ShiftInputsAttributesByDate } => {
  const snakeCaseResult: ShiftsAttributesByDate = {}
  const camelCaseResult: ShiftInputsAttributesByDate = {}

  for (const rowId in daysByRow) {
    const dates = daysByRow[rowId]

    if (!dates) return { snakeCase: {}, camelCase: {} }

    const [locationId, workAreaId] = rowId.split('-')
    const location_id = locationId ? String(locationId) : null
    const work_area_id = workAreaId && workAreaId != NO_WORK_AREA ? String(workAreaId) : null

    dates.forEach((date: string) => {
      snakeCaseResult[date] ||= []
      camelCaseResult[date] ||= []

      snakeCaseResult[date].push({ location_id, work_area_id })
      camelCaseResult[date].push({ locationId: location_id, workAreaId: work_area_id })
    })
  }

  return { snakeCase: snakeCaseResult, camelCase: camelCaseResult }
}

/**
 * @deprecated Use useDefaultAttributesFromRowsGraphQL instead, which works using mutations.
 */
const useDefaultAttributesFromRows = (): ShiftsAttributesByDate => {
  const [{ view }] = useSchedule()
  const { isEnabled: hasSelection, daysByRow } = useSelectionState()

  if (!hasSelection) return {}

  if (view.isByAreas) {
    return getDefaultAttributesFromWorkAreas(daysByRow).snakeCase
  }

  return {}
}

const useDefaultAttributesFromRowsGraphQL = (): ShiftInputsAttributesByDate => {
  const [{ view }] = useSchedule()
  const { isEnabled: hasSelection, daysByRow } = useSelectionState()

  if (!hasSelection) return {}

  if (view.isByAreas) {
    return getDefaultAttributesFromWorkAreas(daysByRow).camelCase
  }

  return {}
}

export { useDefaultAttributesFromRows, useDefaultAttributesFromRowsGraphQL }
